import { useContext } from 'react';
import S3DataAuthContext from './S3DataAuthContext';
const useS3DataAuth = () => {
    const context = useContext(S3DataAuthContext);
    return context;
};
export default useS3DataAuth;
